/**
 * env统一导出文件
 * */
import ConfigDev from './env.dev';
import Config from './env';
import ExPandsConfig from './staging/env.stag';

const exportConfig =
  process.env.NODE_ENV === 'development'
    ? { ...Config, ...ConfigDev }
    : { ...Config, ...ExPandsConfig };

export default exportConfig;
